import React, { useCallback, useEffect, useState } from 'react';
import BudgetComponents from '../../components/establish/BudgetComponents';
import { getDeptList, setBudget, getBudget } from '../../lib/api/establish';
import { useSnackbar } from 'notistack';

const BudgetContainer = () => {
  const [deptList, setDeptList] = useState([]); 
  const [loading, setLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  
  const [selectedYear, setSelectedYear] = useState(2026); 
  const { enqueueSnackbar } = useSnackbar();

  const fetchInitialData = useCallback(async (year) => {
    if (!year) return;
    setLoading(true);

    try {
      const deptRes = await getDeptList();
      const depts = deptRes.data?.list || [];

      if (depts.length === 0) {
        setDeptList([]);
        return;
      }

      let savedBudgets = [];
      try {
        const budgetRes = await getBudget(year);
        savedBudgets = budgetRes.data?.list || [];
      } catch (err) {
        console.warn('저장된 예산 데이터가 없습니다. (기본값 0으로 표시)');
      }

      const mergedData = depts.map(dept => {
        const saved = savedBudgets.length > 0 
          ? savedBudgets.find(b => b.dptUuid === dept.dptUuid) 
          : null;
        
        return {
          id: dept.dptUuid,
          dept: dept.dptNm,
          direct: saved ? (saved.directAmt || 0) : 0,
          commonRate: saved ? (saved.commonRate || 0) : 0,
          strategyRate: saved ? (saved.strategyRate || 0) : 0,
          commonBudget: saved ? (saved.commonBudgetAmt || 0) : 0,
          strategyBudget: saved ? (saved.strategyBudgetAmt || 0) : 0,
          totalBudget: saved ? (saved.totalBudgetAmt || 0) : 0
        };
      });

      setDeptList(mergedData);
    } catch (e) {
      console.error('부서 정보 로드 실패:', e);
      enqueueSnackbar('부서 목록을 불러오는 중 오류가 발생했습니다.', { variant: 'error' });
    } finally {
      setLoading(false);
    }
  }, [enqueueSnackbar]);

  useEffect(() => {
    fetchInitialData(selectedYear);
  }, [selectedYear, fetchInitialData]);

  const onSave = async (finalData) => {
    setIsSaving(true);
    try {
      const response = await setBudget(finalData);

      if (response.data.result === 'success') {
        enqueueSnackbar('성공적으로 저장되었습니다.', { variant: 'success' });
        fetchInitialData(selectedYear); 
      }
    } catch (err) {
      console.error('저장 오류:', err);
      const message = err.response?.data?.message || err.message || '저장 중 오류가 발생했습니다.';
      enqueueSnackbar(message, { variant: 'error' });
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <BudgetComponents 
      deptList={deptList} 
      onSave={onSave} 
      isLoading={loading || isSaving}
      selectedYear={selectedYear}
      setSelectedYear={setSelectedYear}
    />
  );
};

export default BudgetContainer;
